import { useMutation } from 'react-query';

import {useAPI} from '..';
import {PATH} from '../../constants/global';

import { UserUpgrade, UseAccountUpgrade } from './useAccountUpgrade.type';

export default function(): UseAccountUpgrade {
    const request = useAPI();
    const { error, isLoading, mutate, isSuccess } = useMutation(upgradeUserAPI);

    async function upgradeUserAPI(user: UserUpgrade) {
        return request.post(PATH.REGISTER.UPGRADE_ACCOUNT, user);
    }

    const upgrade = (user: UserUpgrade): void => {
        mutate(user);
    }

    return {
        // @ts-ignore
        error: error?.response.data?.Message,
        isLoading,
        isSuccess,
        upgrade,
    }
}